"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.receiveDynoById = receiveDynoById;
exports.updateDynosTableSorting = updateDynosTableSorting;
exports.updateDynosTableSearch = updateDynosTableSearch;
exports.receiveDynosAnalytics = receiveDynosAnalytics;
exports.fetchDynosAnalytics = fetchDynosAnalytics;
exports.fetchDynosIfNeeded = fetchDynosIfNeeded;
exports.fetchDynoIfNeeded = fetchDynoIfNeeded;
exports.switchEnableDyno = switchEnableDyno;
exports.deleteDyno = deleteDyno;
exports.navigateToDynoByGuid = navigateToDynoByGuid;
exports.cloneDyno = cloneDyno;

var _underscore = require("underscore");

var _reactRouterRedux = require("react-router-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _ActionTypes = require("lead-flows-ui/constants/ActionTypes");

var _DynosApiClient = _interopRequireDefault(require("lead-flows-ui/api/DynosApiClient"));

var _AnalyticsApiClient = _interopRequireDefault(require("lead-flows-ui/api/AnalyticsApiClient"));

var _ActionUtils = require("lead-flows-ui/utils/ActionUtils");

var _RouteGenerators = require("lead-flows-ui/lib/RouteGenerators");

var _NotificationUtils = require("lead-flows-ui/utils/NotificationUtils");

var _ErrorUtils = require("lead-flows-ui/utils/ErrorUtils");

var _eventsTrackerUtils = require("lead-flows-ui/utils/eventsTrackerUtils");

function requestDynos() {
  return {
    type: _ActionTypes.REQUEST_DYNOS
  };
}

function receiveDynos(response) {
  return {
    type: _ActionTypes.RECEIVE_DYNOS,
    payload: {
      dynos: response.results,
      totalCount: response.total,
      offset: response.offset,
      hasMore: response.hasMore
    },
    meta: {
      timestamp: Date.now()
    }
  };
}

function errorDynos(error) {
  return {
    type: _ActionTypes.ERROR_DYNOS,
    payload: error,
    error: true
  };
}

function requestDynoById() {
  return {
    type: _ActionTypes.REQUEST_DYNO_BY_ID
  };
}

function receiveDynoById(dyno) {
  return {
    type: _ActionTypes.RECEIVE_DYNO_BY_ID,
    payload: dyno
  };
}

function errorDynoById(error) {
  return {
    type: _ActionTypes.ERROR_DYNO_BY_ID,
    payload: error,
    error: true
  };
}

function updateDynosTableSorting(col, dir) {
  return {
    type: _ActionTypes.UPDATE_DYNOS_TABLE_SORTING,
    col: col,
    dir: dir
  };
}

function updateDynosTableSearch(searchTerm) {
  return {
    type: _ActionTypes.UPDATE_DYNOS_TABLE_SEARCH,
    search: searchTerm
  };
}

function requestDynosAnalytics() {
  return {
    type: _ActionTypes.REQUEST_DYNOS_ANALYTICS
  };
}

function receiveDynosAnalytics(payload) {
  return {
    type: _ActionTypes.RECEIVE_DYNOS_ANALYTICS,
    payload: payload,
    meta: {
      timestamp: Date.now()
    }
  };
}

function errorDynosAnalytics(payload) {
  return {
    type: _ActionTypes.ERROR_DYNOS_ANALYTICS,
    error: true,
    payload: payload
  };
}

function requestDynoEnableSwitch(id) {
  return {
    type: _ActionTypes.REQUEST_DYNO_ENABLE_SWITCH,
    id: id
  };
}

function receiveDynoEnableSwitch(dyno) {
  return {
    type: _ActionTypes.RECEIVE_DYNO_ENABLE_SWITCH,
    id: dyno.id,
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('success', _I18n.default.text('notification.unpublishDyno.success', {
        name: dyno.name
      }))
    }
  };
}

function errorDynoEnableSwitch(id, errorType) {
  var messageKey = "leadFlows.listTable.error." + errorType;
  var message = _I18n.default.lookup(messageKey) ? _I18n.default.text(messageKey) : _I18n.default.text('leadFlows.listTable.error.unknown');
  return {
    type: _ActionTypes.ERROR_DYNO_ENABLE_SWITCH,
    id: id,
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('danger', message)
    }
  };
}

function requestDynoDelete() {
  return {
    type: _ActionTypes.REQUEST_DYNO_DELETE
  };
}

function receiveDynoDelete(id) {
  return {
    type: _ActionTypes.RECEIVE_DYNO_DELETE,
    payload: {
      id: id
    },
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('success', _I18n.default.text('notification.removeDyno.success'))
    }
  };
}

function errorDynoDelete(id) {
  return {
    type: _ActionTypes.ERROR_DYNO_DELETE,
    payload: {
      id: id
    },
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('danger', _I18n.default.text('notification.removeDyno.error'))
    }
  };
}

function removeErrorDynoDelete(id) {
  return {
    type: _ActionTypes.REMOVE_ERROR_DYNO_DELETE,
    id: id
  };
}

function requestDynoClone() {
  return {
    type: _ActionTypes.REQUEST_DYNO_CLONE
  };
}

function receiveDynoClone(payload) {
  return {
    type: _ActionTypes.RECEIVE_DYNO_CLONE,
    payload: payload,
    meta: {// notification: createTopNotification('success', I18n.text('notification.cloneDyno.success')),
    }
  };
}

function errorDynoClone(id) {
  return {
    type: _ActionTypes.ERROR_DYNO_CLONE,
    payload: {
      id: id
    },
    meta: {
      notification: (0, _NotificationUtils.createTopNotification)('danger', _I18n.default.text('notification.cloneDyno.error'))
    }
  };
}

function removeErrorDynoClone(id) {
  return {
    type: _ActionTypes.REMOVE_ERROR_DYNO_CLONE,
    id: id
  };
}

function fetchDynosAnalytics(formGuids, startDate, endDate) {
  return function (dispatch) {
    if (!formGuids.length) return;
    dispatch(requestDynosAnalytics()); // eslint-disable-next-line

    return _AnalyticsApiClient.default.fetchDynosAnalytics(formGuids, startDate, endDate).then(function (response) {
      dispatch(receiveDynosAnalytics(response));
    }, function (error) {
      dispatch(errorDynosAnalytics(error.xhr));
    });
  };
}

function fetchDynos() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var count = arguments.length > 1 ? arguments[1] : undefined;
  var searchTerm = arguments.length > 2 ? arguments[2] : undefined;
  return function (dispatch) {
    dispatch(requestDynos());
    return _DynosApiClient.default.fetchDynos(offset, count, searchTerm).then(function (response) {
      dispatch(receiveDynos(response));

      if (response && response.total > 0) {
        var formGuids = response.results.map(function (d) {
          return d.formGuid;
        });
        dispatch(fetchDynosAnalytics(formGuids));
      }
    }, function (error) {
      dispatch(errorDynos(error.xhr));
    }).done();
  };
}

function fetchDynosIfNeeded() {
  return function (dispatch, getState) {
    var state = getState();
    var dynos = state.dynos;
    var offset = dynos.offset;
    var count = 10;

    if ((0, _ActionUtils.basicShouldFetchChecker)(state, 'dynos')) {
      return dispatch(fetchDynos(offset, count, dynos.table.search));
    }

    return true;
  };
}

function fetchDynoById(id) {
  return function (dispatch) {
    dispatch(requestDynoById());
    return _DynosApiClient.default.fetchDyno(id).then(function (response) {
      dispatch(receiveDynoById(response));
    }, function (error) {
      dispatch(errorDynoById(error.xhr));
    }).done();
  };
}

function fetchDynoIfNeeded(id) {
  return function (dispatch, getState) {
    var dynoById = getState().dynos.dynosById[id];

    if (!dynoById) {
      return dispatch(fetchDynoById(id));
    }

    return dynoById;
  };
}

function switchEnableDyno(dyno) {
  return function (dispatch) {
    dispatch(requestDynoEnableSwitch(dyno.id));
    var dynoUpdate = (0, _underscore.pick)(dyno, 'id', 'enabled');
    return _DynosApiClient.default.partialUpdateDyno(dynoUpdate).then(function () {
      dispatch(receiveDynoEnableSwitch(dyno));
      dispatch(receiveDynoById(dyno));

      if (dyno.enabled) {
        // ********** PUBLIC EVENT **********
        // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
        // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
        // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
        (0, _eventsTrackerUtils.trackDashboardInteraction)('publish-lead-flow');
      }
    }, function (_ref) {
      var xhr = _ref.xhr;

      var _parseResponseJson = (0, _ErrorUtils.parseResponseJson)(xhr.response),
          errorType = _parseResponseJson.errorType;

      dispatch(errorDynoEnableSwitch(dyno.id, errorType));
      (0, _eventsTrackerUtils.trackDashboardInteraction)('publish-lead-flow-failure');
    }).done();
  };
}

function deleteDyno(id) {
  return function (dispatch) {
    dispatch(requestDynoDelete());
    return _DynosApiClient.default.deleteDyno(id).then(function () {
      dispatch(receiveDynoDelete(id));
      (0, _eventsTrackerUtils.trackDashboardInteraction)('delete-lead-flow');
    }, function () {
      dispatch(errorDynoDelete(id));
      setTimeout(function () {
        return dispatch(removeErrorDynoDelete(id));
      }, 5000);
      (0, _eventsTrackerUtils.trackDashboardInteraction)('delete-lead-flow-failure');
    }).done();
  };
}

function _fetchDynoByGuid(formGuid) {
  return {
    type: _ActionTypes.FETCH_DYNO_BY_GUID,
    formGuid: formGuid
  };
}

function _failedToGetDynoByGuid(formGuid) {
  return {
    type: _ActionTypes.FAILED_TO_GET_DYNO_BY_GUID,
    formGuid: formGuid
  };
}

function navigateToDynoByGuid(formGuid) {
  var openEditorOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return function (dispatch) {
    dispatch(_fetchDynoByGuid());
    return _DynosApiClient.default.fetchDynoByGuid(formGuid).then(function (response) {
      var routeGenerator = !openEditorOnly ? _RouteGenerators.getDynoDetailsRoute : _RouteGenerators.getDynoEditorRoute;

      if (response.id) {
        dispatch((0, _reactRouterRedux.replace)(routeGenerator(response.id)));
      } else {
        dispatch(_failedToGetDynoByGuid(formGuid));
      }
    }, function (error) {
      return dispatch(errorDynos(error.xhr));
    });
  };
}

function cloneDyno(id, name) {
  return function (dispatch) {
    dispatch(requestDynoClone());
    return _DynosApiClient.default.cloneDyno(id, name).then(function (response) {
      dispatch(navigateToDynoByGuid(response.formGuid, true));
      dispatch(receiveDynoClone(response));
      (0, _eventsTrackerUtils.trackDashboardInteraction)('clone-lead-flow');
    }, function () {
      dispatch(errorDynoClone(id));
      setTimeout(function () {
        return dispatch(removeErrorDynoClone(id));
      }, 5000);
      (0, _eventsTrackerUtils.trackDashboardInteraction)('clone-lead-flow-failure');
    }).done();
  };
}